import { removeEmptyNullAndUndefinedFromObject } from "../../utils/common";

/** */
const buildEndPoint = (params, basePath) => {
  const options = {
    pageType: params?.pageType || "dateRange",
    categoryId: params?.categoryId || "",
    productId: params?.productId || "",
    month: params?.month || "",
    year: params?.year || "",
    domainId: "fnp.com",
    page: params?.pageNumber || 0,
    size: 20,
    requestType: "",
  };
  const filteredParams = removeEmptyNullAndUndefinedFromObject(options);
  const flattenedParams = new URLSearchParams(filteredParams).toString();
  return `${basePath}?${decodeURIComponent(flattenedParams)}`;
};

/**
 * Builds the categoryUrl param for category reviews API requests.
 *
 * @param {string} categoryId - Category identifier, with or without the `-lp` suffix.
 * @returns {string} Category URL in the format `fnp.com/{categoryId}-lp`.
 */
export const buildTestimonialsCategoryUrl = (categoryId) => {
  if (!categoryId) {
    return "";
  }

  const categorySlug = categoryId.endsWith("-lp") ? categoryId : `${categoryId}-lp`;
  return `fnp.com/${categorySlug}`;
};

/**
 * Endpoint for fetching category reviews from the search service.
 *
 * @param {object} params - Parameters for the endpoint.
 * @param {string} params.categoryId - Category identifier.
 * @param {number} [params.pageNumber=0] - Page number.
 * @param {number} [params.size=12] - Page size.
 * @returns {string} The URL of the API endpoint to fetch category reviews.
 */
export const categoryReviewsEndPoint = (params) => {
  const options = {
    categoryUrl: buildTestimonialsCategoryUrl(params?.categoryId),
    page: params?.pageNumber ?? 0,
    size: params?.size ?? 12,
  };
  const filteredParams = removeEmptyNullAndUndefinedFromObject(options);
  const flattenedParams = new URLSearchParams(filteredParams).toString();
  return `/search/v1/category/reviews?${decodeURIComponent(flattenedParams)}`;
};

/**
 * Endpoint for fetching testimonials.
 *
 * @param {object} params - Parameters for the endpoint.
 * @returns {string} The URL of the API endpoint to fetch testimonials.
 */
export const testimonialsEndPoint = (params) => {
  return buildEndPoint(params, "/moody/v1/testimonials");
};
/**
 * Endpoint for fetching ratings.
 *
 * @param {object} params - Parameters for the endpoint.
 * @returns {string} The URL of the API endpoint to fetch ratings.
 */
export const ratingsEndPoint = (params) => {
  const basePath =
    params?.pageType === "category"
      ? "/moody/v1/category/ratings"
      : params?.pageType === "product"
        ? "/moody/v1/product/rating"
        : "/moody/v1/testimonials";
  return buildEndPoint(params, basePath);
};
